import {IsArray, IsInt, IsOptional, IsString} from 'class-validator';

export class ProductFeatureFeedbackStep1Dto {
  @IsString()
  featureKey!: string;

  @IsInt()
  score!: number;

  @IsOptional()
  @IsString()
  content?: string | null;

  @IsOptional()
  @IsArray()
  @IsString({each: true})
  chips?: string[] | null;
}
